import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface SavedSearchesTemplateState {
  clientId: string;
}

const initialState: SavedSearchesTemplateState = {
  clientId: '',
};

const savedSearchesTemplateSlice = createSlice({
  name: 'savedSearchesTemplate',
  initialState,
  reducers: {
    setClientId(state, action: PayloadAction<string>) {
      state.clientId = action.payload;
    },
  },
  selectors: {
    getClientId(state) {
      return state.clientId;
    },
  },
});

export const {setClientId} = savedSearchesTemplateSlice.actions;
export const {getClientId} = savedSearchesTemplateSlice.selectors;

export default savedSearchesTemplateSlice.reducer;
